<template>
  <div>
    <!-- Modificatore della variabile act-for per richiedere dati di altre aziende -->
    <!-- associate al referente aziendale -->
    <SwitcherAziende/>

    <PageTagline :is_ref_azi_area="true" :elements="tagline_elem"/>

    <!-- Overlay di caricamento/invio messaggio -->
    <CustomOverlay :show="show_overlay" :text="overlay_text">

      <!-- Card di contenimento della pagina -->
      <b-card title="Messaggistica interna" class="mr-1 ml-1">
        <!-- Bottone messaggi inviati -->
        <b-card no-body class='mb-2 p-2'>
          <b-row>
            <b-col>
              <b-button variant='primary' size='sm' @click="show_message_sent=true">
                <b-icon icon="envelope-open" class="mr-1"></b-icon> Visualizza Messaggi Inviati
              </b-button>
              <b-button class="ml-2" variant='primary' size='sm' @click="show_archived_message=true">
                <b-icon icon="archive-fill" class="mr-1"></b-icon> Non trovi i messaggi più vecchi? Consulta l'archivio
              </b-button>
            </b-col>
          </b-row>
        </b-card>
        <!-- Sezione invio nuovo messaggio -->
        <b-card no-body>
          <b-card-header>
            <h5><b-icon icon="file-text" class="mr-1"></b-icon> Nuovo messaggio</h5>
          </b-card-header>
          <b-card-body>
            <b-row>
              <!-- Selezione destinatari -->
              <b-col cols="12">
                <p class='text-justify'>
                  Invia messaggi di testo ai dipendenti dell'azienda per la quale stai operando. I messaggi inviati compariranno nell'area delle "Notifiche Welfarebit".
                </p>
              </b-col>
              <b-col cols="12" class="mb-4">
                <h5>Selezione destinatari:</h5>
                <p class='helptext'>Sono visualizzati i soli utenti con contratto welfare attivo.</p>
                <div id='lista_destinatari' class='mt-3'>
                  <b-form-checkbox-group
                    stacked
                    size="sm"
                    v-model="selected_dest"
                    :options="lista_destinatari"
                    class="mb-3"
                    value-field="id"
                    text-field="nome"
                  ></b-form-checkbox-group>
                </div>
                <p class='mt-2'>Selezionati {{num_dest_selezionati}} utenti su {{num_destinatari}}.</p>
                <b-button @click="seleziona_tutti()" variant='primary' size='sm' class='mt-2 mr-1'>Seleziona tutti</b-button>
                <b-button @click="resetta_destinatari()" variant='primary' size='sm' class='mt-2 ml-1'>Resetta selezione</b-button>
              </b-col>
              <!-- Area messaggio -->
              <b-col cols="12">
                <h5>Testo del messaggio:</h5>
                <ckeditor :editor="editor" v-model="editor_data" :config="editor_config"></ckeditor>
                <p :style="max_text_color">{{this.editor_data.length}} caratteri usati su {{this.max_text}} ( Inclusa Formattazione )</p>
              </b-col>
              <!-- Pulsante di invio -->
              <b-col cols="12">
                <b-button @click="conferma_invio()" :disabled="send_button_disabled" class='mt-3' variant='primary'>Invia Messaggio</b-button>
              </b-col>
            </b-row>
          </b-card-body>
        </b-card>
      </b-card>
    </CustomOverlay>

    <!-- Modale per visualizzare i messaggi inviati -->
    <b-modal v-model='show_message_sent' size="xl" hide-header scrollable>
      <TabellaNotifiche :mode="'inviati'" :table_title="'Messaggi inviati'" :show_dest="true" :archive="false"/>
      <template v-slot:modal-footer="{ cancel }">
          <b-button variant="primary" size="sm" class="float-right" @click="cancel()">Chiudi</b-button>
      </template>
    </b-modal>

    <!-- Modale per visualizzare l'archivio dei messaggi inviati -->
    <b-modal v-model='show_archived_message' size="xl" hide-header scrollable>
      <TabellaNotifiche :mode="'inviati'" :table_title="archive_title" :show_dest="true" :archive="true"/>
      <template v-slot:modal-footer="{ cancel }">
          <b-button variant="primary" size="sm" class="float-right" @click="cancel()">Chiudi</b-button>
      </template>
    </b-modal>

  </div>
</template>

<script>
import PageTagline from '@/components/PageTagline'
import SwitcherAziende from '@/components/refaziendale/SwitcherAziende.vue'
import CustomOverlay from '@/components/CustomOverlay'
import TabellaNotifiche from '@/components/TabellaNotifiche'

import CKEditor from '@ckeditor/ckeditor5-vue2';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import '@ckeditor/ckeditor5-build-classic/build/translations/it.js';

import { generalLib } from '@/generalLib'
import { apiUrl } from '@/apiUrl'
import axios from 'axios'

export default {
    name: 'MessInterna',
    data () {
      return {
        // Variabili di base della pagina
        tagline_elem : [ { text : "Messaggistica interna", link: "office-mess-interna" } ],

        // Variabile per visualizzare la modale con i messaggi inviati
        show_message_sent : false,

        // Variabile per visualizzare la modale con i messaggi che sono stati inviati
        // in passato ma che ora trovan posto in archivio
        show_archived_message : false,

        // Titolo della modale per la visualizzazione dei messaggi in archivio,
        // essendo particolarmente lungo lo abbiamo messo qui.
        archive_title : "Archivio Messaggi Inviati - Ricerca tra i messaggi inviati in passato non più disponibili nella casella principale.",

        // Massimi caratteri ( incluso l'html che è possibile inserire )
        // e colore di default ( nero ), quando il numero di caratteri
        // non eccede il consentito.
        max_text : 8000,
        max_text_color : { 'color' : '#000000' },

        // Overlay di caricamento, in questo caso il testo
        // è null perchè diverso in fase di caricamento od
        // in fase di invio messaggio
        show_overlay : false,
        overlay_text : null,

        // Selezione dei destinatari
        lista_destinatari : [],
        selected_dest : [],

        // Variabili dell'editor WYSIWYG
        // L'editor è stato includo con le feature minime della classic build.
        // E' possibile compilarlo online con delle build personalizzate che aggiungono
        // le altre feature ma al momento si verifica un errore di out of memory
        // che impedisce questo. Questa la issue aperta:
        // https://github.com/ckeditor/ckeditor5-angular/issues/274
        // La quale è anche riportata in documentazione, per ora solo in quella di react:
        // https://ckeditor.com/docs/ckeditor5/latest/installation/getting-started/frameworks/react.html#the-javascript-heap-out-of-memory-error
        // Si potrebbe usare il truppo di aumentare la memoria a node.js ma dovremmo
        // farlo anche per il server di sviluppo di vue e non è il caso di andare
        // a toccare queste cose. Lasciamo quindi per il momento l'editor base in
        // attesa che sia risolto il problema.
        // In data 27/10/2023 abbiamo aggiunto un controllo sul numero massimo di caratteri che possono
        // essere usati per scrivere la mail, avremmo dovuto usare il plugin WordCount ma non si riesce
        // ad integrarlo alla classic build esistente ( per ora l'unica utilizzabile ) visto che
        // falliscono il caricamento di alcune dipendenze.
        editor_data: '',
        editor: ClassicEditor,
        editor_config: {
          language : 'it',
          toolbar: {
            items: [
              'heading', '|',
              'bold', 'italic', 'bulletedList', 'numberedList', '|',
              'outdent', 'indent', '|',
              'undo', 'redo', 'link' ],
              shouldNotGroupWhenFull: true
          }
        }
      }
    },
    computed : {
      /**
       * Torna una variabile con il numero di utenti disponibili per l'invio
       */
      num_destinatari : function (){
        return this.lista_destinatari.length;
      },
      /**
       * Torna una variabile con il numero di destinatari selezionati per l'invio.
       */
      num_dest_selezionati : function (){
        return this.selected_dest.length;
      },
      /**
       * Torna un boleano che ci dice se il bottone di invio è abilitato o meno,
       * infatti dobbiamo avere almeno un destinatario selezionato per inviare
       * il messaggio ed il testo del messaggio non deve essere nullo.
       */
      send_button_disabled : function () {
        return this.selected_dest.length > 0 && this.editor_data.length > 0 && this.editor_data.length <= this.max_text ? false : true;
      }
    },
    watch : {
      /**
       * Il Watcher attaccato al contenuto dell'editor colora di rosso la stringa di conteggio dei caratteri quando si eccede
       * la dimensione massima.
       * Non siamo infatti ancora riusciti ad integrare il plugin WordCOunt di CkEditor ( vedi appunti sopra ).
       */
      editor_data ( new_text ) {
          if ( new_text.length > this.max_text ){
            this.max_text_color.color = '#fc1212';
          } else {
            this.max_text_color.color = '#000000';
          }
      }
    },
    methods : {
      /**
       * Seleziona tutti i destinatari
       */
      seleziona_tutti : function () {
        this.resetta_destinatari();
        for ( let elem of this.lista_destinatari ){
          this.selected_dest.push( elem.id );
        }
      },
      /**
      * Resetta i destinatari selezionati
      */
      resetta_destinatari : function () {
        this.selected_dest = new Array();
      },
      /**
       * Chiede all'utente conferma di invio del messaggio ai destinatari,
       * in caso di risposta affermativa procede altrimenti torna senza fare nulla.
       */
      conferma_invio : function () {

        let info_mess = "Confermando sarà inviato il messaggio agli utenti desiderati. " +
                        "L'operazione non potrà essere annullata e potrebbe richiedere " +
                        "qualche secondo per essere completata se il numero di destinatari " +
                        "è particolarmente alto. Si è sicuri di procedere?"
        this.$bvModal.msgBoxConfirm( info_mess, {
          title: 'Conferma Operazione',
          hideHeaderClose: true,
          centered: true
        })
        .then( ( value ) => {
          if ( value ) this.invia_messaggio();
        });
      },
      /**
       * Invia il messaggio agli utenti selezionati. Non richiede ulteriore conferma.
       */
      invia_messaggio : function () {

        this.overlay_text = "Invio del messaggio in corso, attendere...";
        this.show_overlay = true;

        let data = { destinatari : this.selected_dest, messaggio : this.editor_data }

        axios.post( apiUrl.mailapi.invia_comunicazione_interna, data )
        .then( ( response ) => {

          this.show_overlay = false;

          // Se tutto ok il backend torna con un 204_NO_CONTENT
          this.$bvModal.msgBoxOk('Messaggio inviato correttamente', {
            title: 'Messaggio inviato',
            centered: true
          })
          .then(value => {
            // Resettiamo la schermata dopo aver dato ok.
            this.resetta_destinatari();
            this.editor_data = '';
          });
        })
        .catch( ( error ) => {
          this.show_overlay = false;
          let mess = "Si è verificato un errore nell'invio del messaggio:"
          generalLib.backend_error_message_box( this, error.response.data, mess );
        });
      }
    },
    /**
     *  Al caricamento prendiamo la lista degli utenti attivi ( cioè con contratto
     *  welfare non scaduto ) all'interno dell'azienda.
     */
    created : function () {

      this.overlay_text = "Caricamento in corso, attendere...";
      this.show_overlay = true;

      axios.get( apiUrl.welfareapi.anagrafica_utenti_by_azienda, { params: { solo_attivi : 1 } } )
      .then( ( response ) => {

        // Compongo l'array dei destinatari, si tratta di un'array di oggetti
        // del tipo ( vedi configurazione delle checkobx ):
        // { id : <id utente> , nome : <cognome e nome> }
        for ( let elem of response.data ){
          let nome_utente = elem.cognome + ' ' + elem.nome;
          this.lista_destinatari.push( { id : elem.id, nome : nome_utente });
        }
        this.show_overlay = false;
      })
      .catch( ( error ) => {
        this.show_overlay = false;
        let mess = "Si è verificato un errore nel caricamento della lista dei destinatari:"
        generalLib.backend_error_message_box( this, error.response.data, mess );
      });

    },
    components: {
      PageTagline,
      SwitcherAziende,
      CustomOverlay,
      TabellaNotifiche,
      ckeditor: CKEditor.component
    }
}
</script>

<style scoped>
/* Rendiamo la lista delle checkbox dei destinatari
   alta al massimo 150px e con lo scroll a lato */
#lista_destinatari {
  max-height: 150px;
  overflow-y: scroll;
}

.helptext {
  font-size: smaller;
  color: grey;
}
</style>